import React, { Fragment } from 'react';
import styled from 'styled-components';
import Container from '../../../../../../components/container';
import Box from '../../../../../../components/box';
import { H3, Cols } from '../../../../components';

const TitleStyled = styled(Box)`
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.24px;
  color: #145a8f;
  margin-bottom: 30px;
`;

const TextStyled = styled(Box)`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.18px;
  color: #3b3939;
  text-align: justify;
`;

const ItemStyled = styled(Box)`
  text-align: left;
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ColsBlockStyled = styled(Box)`
  @media (max-width: 768px) {
    padding-left: 0 !important;
  }
`;

const ITEMS = [
  {
    description: (
      <Fragment>
        <ItemStyled>
          <TitleStyled>La meilleure rémunération du marché</TitleStyled>

          <TextStyled>
          <b>768 € par mois</b> pour seulement 5 heures par semaine dans le supérieur<br />
          <b>528 € par mois</b> pour seulement 5 heures par semaine niveau lycée<br />
          <br />
            {/* Évidemment, tout dépend du nombre d’heures que tu délivres. Une chose est sûr : nous avons du travail pour toi ! Les étudiants les plus disponibles gagnent jusqu’à 800€ par mois. Sans doute, le meilleur job étudiant ! */}
            Évidemment, tout dépend du nombre de cours que tu dispenses. Une chose est sûr : nous avons du travail pour toi ! Les tuteurs et tutrices les plus disponibles gagnent <b>jusqu’à 1600 € par mois</b>. Sans doute, le meilleur job étudiant !
          </TextStyled>
        </ItemStyled>

        <ItemStyled>
          <TitleStyled>Quand et comment suis-je payé ?</TitleStyled>

          <TextStyled>
            Les étudiants sont rémunérés par virement,
            à la fin du mois et ce, dès la première heure de cours.<br/><br/>

            Les cours ont lieu chez la famille. C’est pourquoi nous te proposons toujours des familles proches de chez toi.
          </TextStyled>
        </ItemStyled>
      </Fragment>
    )
  },

  {
    description: (
      <ItemStyled>
        <TitleStyled>Une équipe pour t'accompagner</TitleStyled>

        <TextStyled>
          Certes, Clevermate se charge de te trouver des clients qualifiés mais nous sommes également là pour s’assurer que tout se passe bien. Alors si tu rencontres une difficulté, quelle qu'elle soit, n'hésite pas à revenir vers nous. Nous sommes là pour ça.
          <br/><br/>
          Comme largement évoqué dans la charte, les étudiants éligibles qui souhaitent nous rejoindre s’engagent à être ponctuel, à structurer leurs cours, et à déclarer leur cours sur l'interface de reporting. Cela permet aux familles de suivre les points abordés lors des cours mais aussi de bénéficier des déductions fiscales.
          <br/><br/>
          Les versements sont effectués automatiquement. Fini les discussions embarrassantes pour se faire payer.
        </TextStyled>
      </ItemStyled>
    )
  }
].map(item => ({descriptionProps: {mt: 0}, ...item}));


const StatusSection = ({title, ...rest}) => {
  return (
    <Container {...rest}>
      <H3 lineBlue>{title}</H3>

      <ColsBlockStyled>
        <Cols items={ITEMS} />
      </ColsBlockStyled>
    </Container>
  )
}

StatusSection.defaultProps = {
  title: 'Donne des cours particuliers, à qui, comment ? Quel statut ?',
};

export default StatusSection;